document.querySelectorAll('[data-board-care-product]').forEach((root) => {
  const picker = root.querySelector('[data-care-variant-picker]');
  const price = root.querySelector('[data-care-price]');
  const compare = root.querySelector('[data-care-compare]');
  const submit = root.querySelector('[data-care-submit]');
  const media = Array.from(root.querySelectorAll('[data-care-media]'));
  const thumbs = Array.from(root.querySelectorAll('[data-care-thumb]'));

  const showMedia = (id) => {
    if (!id) return;
    let found = false;
    media.forEach((item) => {
      const active = item.dataset.careMedia === id;
      item.classList.toggle('is-active', active);
      found = found || active;
    });
    if (!found) return;
    thumbs.forEach((thumb) => {
      thumb.setAttribute('aria-current', thumb.dataset.careThumb === id ? 'true' : 'false');
    });
  };

  const updateVariant = () => {
    if (!picker) return;
    const option = picker.options[picker.selectedIndex];
    price.textContent = option.dataset.price;
    if (option.dataset.compare) {
      compare.textContent = option.dataset.compare;
      compare.hidden = false;
    } else {
      compare.hidden = true;
    }
    submit.disabled = option.dataset.available !== 'true';
    submit.textContent = option.dataset.available === 'true' ? 'Add to Cart' : 'Sold Out';
    showMedia(option.dataset.media);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  };

  if (picker) picker.addEventListener('change', updateVariant);
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.careThumb)));
});
